import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "create-theme",
  initialState: initialState,
  reducers: {
    initCreateTheme: () => {
      return { ...initialState };
    },
    startCreateTheme: (state) => {
      state.loading = true;
    },
    successCreateTheme: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorCreateTheme: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initCreateTheme,
  startCreateTheme,
  successCreateTheme,
  errorCreateTheme,
} = dataSlice.actions;

export default dataSlice.reducer;
